import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const HeaderColorMenu = ({
  toggleDrawer,
  editItem,
  headerItemData,
  handleApi,
  isMobile,
}) => {
  let mobileMenuItem =
    editItem.item === "search" ? "mobileSearch" : "mobileItems";
  const designList = [
    {
      key: "textColor",
      name: "Text - Default Color",
    },
    {
      key: "backgroundColor",
      name: "Button - Default Color",
    },
    {
      key: "borderColor",
      name: "Button - Border Color",
    },
  ];

  return (
    <Box
      sx={{
        borderRadius: "5px",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f4f4f4",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            padding: "5px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textTransform: "capitalize",
            }}
          >
            Edit {editItem.item}
          </Typography>
          <Button
            variant="text"
            sx={{ fontWeight: "bold", color: "#fff" }}
            onClick={() => {
              toggleDrawer(true, editItem.index, "customizeHeader");
            }}
          >
            Back
          </Button>
        </Box>
        <Box
          sx={{
            height: "40px",
            display: "flex",
            alignItems: "center",
            padding: "0 5px",
            borderBottom: "2px solid #B5B5B5",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "17px",
              textTransform: "capitalize",
            }}
          >
            Edit Color
          </Typography>
        </Box>
        {designList.map((item, index) => {
          return (
            <Box
              key={item.key}
              sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                padding: "0 5px",
                borderBottom: "2px solid #B5B5B5",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  columnGap: "10px",
                }}
              >
                <Typography variant="subtitle1">{item.name}</Typography>

                <Button
                  variant="outlined"
                  onClick={() =>
                    toggleDrawer(
                      editItem.open,
                      editItem.index,
                      "picker",
                      item.key,
                      editItem.item
                    )
                  }
                  sx={{
                    background: isMobile
                      ? headerItemData.customHeader?.customHeader
                          ?.customizeHeader[mobileMenuItem][item.key]
                      : headerItemData.customHeader?.customHeader
                          ?.customizeHeader[editItem.item][item.key],
                    width: "40px",
                    height: "40px",
                    minWidth: "40px",
                    border: "1px solid #ccc",
                  }}
                ></Button>
              </Box>
            </Box>
          );
        })}

        <Box
          sx={{
            height: "50px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 5px",
            borderBottom: "2px solid #B5B5B5",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "17px",
              textTransform: "capitalize",
            }}
          >
            Edit Shadow
          </Typography>

          <IconButton
            onClick={() => {
              toggleDrawer(
                editItem.open,
                editItem.index,
                "shadowGenerator",
                null,
                editItem.item
              );
            }}
          >
            <ArrowRightAltIcon /> {/* Changed the icon */}
          </IconButton>
        </Box>
      </Box>
      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{
          fontSize: "12px",
          padding: "6px",
          width: "90%",
          borderRadius: "50px",
          margin: "15px 0",
        }}
        onClick={handleApi}
      >
        Save
      </Button>
    </Box>
  );
};

export default HeaderColorMenu;
